<script setup lang="ts">
import type { Price, ResultsPriceSelectProperties } from '@optionway/models';

const prefix = 'components.results.searchResult';

defineEmits(['selectResult']);

const properties = defineProps<ResultsPriceSelectProperties & Price & { loading?: boolean }>();

const sheetOpen = ref(false);
</script>

<template>
  <div class="flex items-center justify-between">
    <UiSkeleton
      v-if="loading"
      class="h-5 w-20"
    />
    <UiButton
      v-else
      variant="tertiary"
      color="gray"
      size="sm"
      padding="none"
      class="font-normal"
      @click="sheetOpen = true"
    >
      <span class="underline">{{ $t(`${prefix}.detailsMobile`) }}</span>
    </UiButton>

    <ResultsPriceSelect
      v-bind="properties"
      v-model:sheet-open="sheetOpen"
      @select-result="$emit('selectResult')"
    />
  </div>
</template>
